import {
  SET_DOCUMENTS_FILTERS,
  SET_DOCUMENTS_FILTERS_LOADING,
  SET_DOCUMENTS_CHOSEN_FILTER,
  SET_DOCUMENTS_CHOSEN_FILTER_NAME,
  SET_DOCUMENTS_FILTERS_ERROR,
} from '../actions/documentFilter/actionTypes';

const defaultState = {
  filters: { isLoading: false, data: [] },
  chosenFilterId: null,
  chosenFilterName: null,
  isError: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_DOCUMENTS_FILTERS:
      return {
        ...state,
        filters: { isLoading: false, data: [...action.payload] },
      };
    case SET_DOCUMENTS_FILTERS_LOADING:
      return {
        ...state,
        filters: { ...state.filters, isLoading: action.payload },
      };
    case SET_DOCUMENTS_CHOSEN_FILTER:
      return { ...state, chosenFilterId: action.payload };
    case SET_DOCUMENTS_CHOSEN_FILTER_NAME:
      return { ...state, chosenFilterName: action.payload };
    case SET_DOCUMENTS_FILTERS_ERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  }
};
